import type { RealtimeChannel } from "@supabase/supabase-js";
import { supabase } from "@/lib/supabase";

type Subscription = { channel: RealtimeChannel; refs: number };

const subscriptions = new Map<string, Subscription>();

export function acquireCreditsRealtime(orgId: string, onChange: (orgId: string) => void) {
  const existing = subscriptions.get(orgId);
  if (existing) {
    existing.refs += 1;
  } else {
    const channel = supabase
      .channel(`credit-balance-${orgId}`)
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "credit_balances", filter: `organization_id=eq.${orgId}` },
        () => onChange(orgId),
      )
      .subscribe();
    subscriptions.set(orgId, { channel, refs: 1 });
  }

  let released = false;
  return () => {
    if (released) return;
    released = true;
    const current = subscriptions.get(orgId);
    if (!current) return;
    current.refs -= 1;
    if (current.refs > 0) return;
    subscriptions.delete(orgId);
    void supabase.removeChannel(current.channel);
  };
}
